import React from 'react';
import '../../styles/website/ScrollingPlanet.css';

const ScrollingPlanet = ({ scrollProgress }) => {
  // Get section info with BETTER colors and designs
  const getSectionPlanet = () => {
    // Calculate smooth zig-zag position based on scroll
    let leftPosition, topPosition, color, secondary, tertiary, type;
    
    if (scrollProgress < 20) {
      // Section 1: Hero - Beautiful AQUA/TEAL planet
      const progress = scrollProgress / 20;
      leftPosition = 15 + (progress * 0);
      topPosition = 15 + (progress * 10);
      color = '#00e6e6';
      secondary = '#00b8d4';
      tertiary = '#006064';
      type = 'nebula';
    } else if (scrollProgress < 40) {
      // Section 2: Domains - Beautiful VIOLET planet with rings
      const progress = (scrollProgress - 20) / 20;
      leftPosition = 15 + (progress * 60);
      topPosition = 25 + (progress * 15);
      color = '#9c27ff';
      secondary = '#7b1fa2';
      tertiary = '#4a148c';
      type = 'saturn';
    } else if (scrollProgress < 60) {
      // Section 3: Astrologer - Beautiful AMBER/GOLD planet
      const progress = (scrollProgress - 40) / 20;
      leftPosition = 75 - (progress * 55);
      topPosition = 40 + (progress * 20);
      color = '#ffa726';
      secondary = '#ff6f00';
      tertiary = '#e65100';
      type = 'jupiter';
    } else if (scrollProgress < 80) {
      // Section 4: B2B - Beautiful ROSE/MAGENTA planet
      const progress = (scrollProgress - 60) / 20;
      leftPosition = 20 + (progress * 50);
      topPosition = 60 + (progress * 20);
      color = '#ec407a';
      secondary = '#c2185b';
      tertiary = '#880e4f';
      type = 'mars';
    } else {
      // Section 5: Power - Beautiful GOLDEN planet
      const progress = (scrollProgress - 80) / 20;
      leftPosition = 70 - (progress * 45);
      topPosition = 80 + (progress * 15);
      color = '#ffd54f';
      secondary = '#ffb300';
      tertiary = '#ff6f00';
      type = 'sun';
    }
    
    return {
      color,
      secondary,
      tertiary,
      type,
      position: { left: `${leftPosition}%`, top: `${topPosition}%` }
    };
  };

  const planet = getSectionPlanet();

  // Render BETTER planet types
  const renderPlanetType = () => {
    switch(planet.type) {
      case 'nebula':
        return (
          <div 
            className="planet-nebula"
            style={{
              background: `radial-gradient(circle at 40% 40%, 
                rgba(255, 255, 255, 0.4) 0%, 
                ${planet.color} 20%, 
                ${planet.secondary} 50%, 
                ${planet.tertiary} 100%)`,
              boxShadow: `
                0 0 60px ${planet.color}99,
                0 0 100px ${planet.secondary}66,
                inset -30px -30px 70px rgba(0, 0, 0, 0.5),
                inset 20px 20px 50px rgba(255, 255, 255, 0.3)
              `
            }}
          >
            <div className="nebula-clouds" style={{ background: `${planet.color}44` }}></div>
          </div>
        );
      
      case 'saturn':
        return (
          <div 
            className="planet-saturn"
            style={{
              background: `radial-gradient(circle at 35% 35%, 
                ${planet.color} 0%, 
                ${planet.secondary} 60%, 
                ${planet.tertiary} 100%)`,
              boxShadow: `
                0 0 70px ${planet.color}88,
                inset -25px -25px 60px rgba(0, 0, 0, 0.6)
              `
            }}
          >
            <div 
              className="planet-rings"
              style={{
                borderColor: `${planet.color}aa`,
                boxShadow: `0 0 40px ${planet.color}cc`
              }}
            ></div>
          </div>
        );
      
      case 'jupiter':
        return (
          <div 
            className="planet-jupiter"
            style={{
              background: `
                repeating-linear-gradient(
                  0deg,
                  ${planet.color} 0px,
                  ${planet.secondary} 20px,
                  ${planet.tertiary} 40px,
                  ${planet.secondary} 60px
                )
              `,
              boxShadow: `
                0 0 80px ${planet.color}77,
                inset -35px -35px 80px rgba(0, 0, 0, 0.4)
              `
            }}
          >
            <div className="jupiter-storm" style={{ background: `${planet.tertiary}dd` }}></div>
          </div>
        );
      
      case 'mars':
        return (
          <div 
            className="planet-mars"
            style={{
              background: `radial-gradient(circle at 35% 35%, 
                ${planet.color} 0%, 
                ${planet.secondary} 50%, 
                ${planet.tertiary} 100%)`,
              boxShadow: `
                0 0 90px ${planet.color}99,
                inset -40px -40px 90px rgba(0, 0, 0, 0.6)
              `
            }}
          >
            <div className="mars-crater" style={{ background: `${planet.tertiary}cc` }}></div>
            <div className="mars-crater crater-2" style={{ background: `${planet.tertiary}99` }}></div>
          </div>
        );
      
      case 'sun':
        return (
          <div 
            className="planet-sun"
            style={{
              background: `radial-gradient(circle at 50% 50%, 
                #ffffff 0%, 
                ${planet.color} 30%, 
                ${planet.secondary} 70%, 
                ${planet.tertiary} 100%)`,
              boxShadow: `
                0 0 100px ${planet.color}dd,
                0 0 140px ${planet.secondary}99,
                inset 0 0 50px ${planet.color}66
              `
            }}
          >
            <div className="sun-flare" style={{ background: `${planet.color}88` }}></div>
          </div>
        );
      
      default:
        return null;
    }
  };

  return (
    <div 
      className="watermark-planet"
      style={{
        left: planet.position.left,
        top: planet.position.top
      }}
    >
      {renderPlanetType()}
    </div>
  );
};

export default ScrollingPlanet;